import api from './api'

export const authApi = {
  // Fazer login
  login: async (username, password, tenantId) => {
    const payload = {
      username,
      password,
    }

    if (tenantId) {
      payload.tenantId = tenantId
    }

    const response = await api.post('/auth/login', {
      ...payload,
    })
    return response.data
  },

  loginWithMfa: async (mfaTicket, code) => {
    const response = await api.post('/auth/login/mfa', {
      mfaTicket,
      code,
    })
    return response.data
  },

  // Renova o JWT (estende a expiração preservando as claims). Bearer adicionado pelo interceptor.
  refresh: async () => {
    const response = await api.post('/auth/refresh')
    return response.data
  },

  startSso: async (provider, redirectUri) => {
    const encodedRedirect = encodeURIComponent(redirectUri)
    const response = await api.post(`/auth/sso/${provider}/start?redirectUri=${encodedRedirect}`)
    return response.data
  },

  completeSso: async (provider, payload) => {
    const response = await api.post(`/auth/sso/${provider}/callback`, payload)
    return response.data
  },

  register: async (name, email) => {
    const response = await api.post('/auth/register', { name, email })
    return response.data
  },

  // Usuário logado atualizado (refresca a sessão no boot, pega campos novos sem relogar)
  getMe: async () => {
    const response = await api.get('/auth/me')
    return response.data
  },

  // Esqueceu a senha - envia nova senha temporária por email
  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email })
    return response.data
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    })
    return response.data
  },

  getMfaStatus: async () => {
    const response = await api.get('/auth/mfa/status')
    return response.data
  },

  startMfaSetup: async () => {
    const response = await api.post('/auth/mfa/setup/start')
    return response.data
  },

  confirmMfaSetup: async (code) => {
    const response = await api.post('/auth/mfa/setup/confirm', { code })
    return response.data
  },

  disableMfa: async (code) => {
    const response = await api.post('/auth/mfa/disable', { code })
    return response.data
  },

  createMfaChallenge: async (code, action, tenantId) => {
    const payload = { code, action }
    if (tenantId) payload.tenantId = tenantId
    const response = await api.post('/auth/mfa/challenge', payload)
    return response.data
  },

  switchTenant: async (tenantId) => {
    const response = await api.post('/auth/switch-tenant', { tenantId })
    return response.data
  },

  updateMyProfilePhoto: async (profilePhotoBase64) => {
    const response = await api.put('/auth/me/profile-photo', { profilePhotoBase64 })
    return response.data
  },

  // Self-service: o próprio usuário edita celular e o opt-in de alertas por WhatsApp
  updateMyContact: async ({ phoneNumber, whatsAppAlertsEnabled }) => {
    const response = await api.put('/auth/me/contact', { phoneNumber, whatsAppAlertsEnabled })
    return response.data
  },

  // Self-service: preferência de formato de data/hora (globaliza no app)
  updateMyPreferences: async ({ dateFormat, timeFormat, timezone }) => {
    const response = await api.put('/auth/me/preferences', { dateFormat, timeFormat, timezone })
    return response.data
  },

  // Validar token (opcional, para verificar se token ainda é válido)
  validateToken: async (token) => {
    // Se necessário, criar endpoint no backend para validar token
    // Por enquanto, vamos apenas verificar se o token existe no localStorage
    return { valid: !!token }
  }
}
